import script from "./CompetitionFixtures.vue?vue&type=script&setup=true&lang=js"
export * from "./CompetitionFixtures.vue?vue&type=script&setup=true&lang=js"

import "./CompetitionFixtures.vue?vue&type=style&index=0&id=03a9ca0d&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-03a9ca0d"]])

export default __exports__